import types from 'components/addresses/actions'

const suggestionSearchText = text => ({
  type: types.SUGGESTION_SEARCH_TEXT,
  text,
})

export default suggestionSearchText
